export default __webpack_public_path__ + "static/media/tv-1.5e05e46f.png";